import { DateTime } from 'luxon';

declare module 'luxon/src/datetime' {
  interface DateTime {
    format(format: string): string;
  }
}
DateTime.prototype.format = function (format: string) {
  return this.toFormat(format);
};

export { DateTime };

export default class QDateTime {
  static locationTime() {
    return DateTime.local();
  }
  static parse(value: string | null) {
    if (value) {
      return DateTime.fromISO(value);
    } else {
      return DateTime.now();
    }
  }
  static parseTimestamp(value: number) {
    return DateTime.fromMillis(+value);
  }

  static formatLocaleWithTime(value: string | null) {
    return QDateTime.parse(value).toLocaleString(DateTime.DATETIME_SHORT);
  }
}
